import { IconProps } from "./types";
import React from "react";

export const ScoreDetailsIcon = ({
  className,
  fill = "currentColor",
  width = 14,
  height = 14,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 14 14"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M9.62503 3.93848H12.6875V7.00098"
      stroke={fill}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M1.31247 10.0625L5.24997 6.125L7.87497 8.75L12.25 4.375"
      stroke={fill}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);
